import * as PropTypes from 'prop-types';
import * as React from 'react';
import { UserStore } from '@reverbdotcom/discovery-ui';
import UrlHelpers from '../shared/url_helpers';
import PromoProduct from './promo_product';
import CSRFForm from '../shared/csrf_form';
import Savings from './savings';
import PriceWithChange from './price_with_change';
import ProductBundleCalculator from './product_bundle_calculator';
import TaxIncludedHint from '../shared/tax_included_hint';

class ProductBundle extends React.Component {
  get renderingBundle() {
    return this.props.productBundle.id;
  }

  renderBundledListings() {
    return this.props.productBundle.bundled_products.map(bundledProduct => (
      <PromoProduct
        key={bundledProduct.listing.id}
        listing={bundledProduct.listing}
        bundledPrice={bundledProduct.listing.buyer_price}
        originalPrice={bundledProduct.listing.original_price}
      />
    ));
  }

  renderSavings() {
    return (
      <Savings
        price={ProductBundleCalculator.originalPrice(this.props.productBundle)}
        bundledPrice={ProductBundleCalculator.discountedPrice(this.props.productBundle)}
        symbol={this.props.productBundle.main_listing.buyer_price.symbol}
        bundledProductsCount={ProductBundleCalculator.bundledProductsCount(this.props.productBundle)}
      />
    );
  }

  renderHiddenData() {
    if (this.renderingBundle) {
      return (
        <input
          type="hidden"
          value={this.props.productBundle.id}
          name="cart_item[product_bundle_id]"
        />
      );
    }

    return (
      <div>
        <input
          type="hidden"
          value={this.props.productBundle.main_listing.id}
          name="cart_item[product_id]"
        />
        { this.props.productBundle.bundled_products.map(product => (
          <input
            key={product.listing.id}
            type="hidden"
            value={product.listing.id}
            name="cart_item[product_ids][]"
          />
        )) }
      </div>
    );
  }

  render() {
    if (!this.props.productBundle.bundled_products.length) {
      return false;
    }

    return (
      <div className="g-container">
        <div className="g-col-6 g-col-mobile-12">
          <PromoProduct
            listing={this.props.productBundle.main_listing}
            originalPrice={this.props.productBundle.main_listing.price}
          />
          { this.renderBundledListings() }
        </div>
        <div className="g-col-1 g-col-mobile-12" />
        <div className="g-col-5 g-col-mobile-12 align-center">
          <div>
            <span className="size-150 weight-bold">
              <PriceWithChange
                price={ProductBundleCalculator.totalBuyerPrice(this.props.productBundle)}
              />
            </span>
            <span className="ml-space size-90">
              <TaxIncludedHint hint={this.props.productBundle.bundled_tax_included_hint} />
            </span>
          </div>
          { this.renderSavings() }
          <CSRFForm action={UrlHelpers.productBundleCartPath} method="POST" className="mt-1">
            <input
              type="hidden"
              value={UserStore.getState().deviceType}
              name="cart_item[action_source_attributes][device]"
            />
            { this.renderHiddenData() }
            <button className="btn btn-primary wide">
              { I18n.t('js.productBundles.promo.addToCart', {
                count: ProductBundleCalculator.bundledProductsCount(this.props.productBundle),
                totalCount:
                  ProductBundleCalculator.bundledProductsCount(this.props.productBundle) + 1,
              }) }
            </button>
          </CSRFForm>
        </div>
      </div>
    );
  }
}

ProductBundle.propTypes = {
  productBundle: PropTypes.object,
};

export default ProductBundle;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/product_bundle.jsx